module.exports = "/_next/static/images/connecticut-94acb9f25f77b715694e6d134639262f.svg";